const drawer = document.querySelector('#cart-flyout-drawer');

setTimeout(function () {
    document.querySelectorAll('.custom-add-to-cart').forEach((el) => {
        el.addEventListener('click', function (e) {
            const variantId = e.target.getAttribute('variant-id');
            // console.log('variantId: ', variantId);
            let allVariants = [{
                id: Number(variantId),
                quantity: 1,
            }];
            addItemToCartMain(allVariants);
        });
    }
    );
    // console.log('adddd-to-cart', document.querySelector('.custom-add-to-cart'));
}, 2500);

//============== add to shopify cart =============
async function addItemToCartMain(variants) {
    document.querySelector('.custom-add-to-cart').classList.add('loading');
    data = {
        items: variants
    }
    // Submit form with ajax
    await fetch("/cart/add.js", {
        method: "POST",
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    }).then(res => res.json()).then(data => {
        // console.log("response", data);
        // drawer.classList.remove('reviews-flyout', 'reviews-flyout--active', 'animation--revealed');
        const openCartEvent = new CustomEvent('updateCartD');
        document.dispatchEvent(openCartEvent);
        // drawer.classList.add('is-active', 'is-visible', 'animation--revealed');
        document.querySelector('.custom-add-to-cart').classList.remove('loading');

    }).catch(err => console.log(err));

}
